const { getWeb3, setWeb3Provider } = require("@openzeppelin/test-helpers/src/config/web3");

module.exports = {
    setWeb3Provider,
    getWeb3
};
